import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { getToken } from './api';

/**
 * Redirects to /login if there's no JWT in localStorage. Doesn't validate
 * the token client-side — that's the server's job. A revoked / expired token
 * surfaces as a 401 on next API call which clears the storage.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const loc = useLocation();
  if (!getToken()) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return <>{children}</>;
}
